import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getUnreadCount } from '../api/buzon/BuzonService';
import { setUnreadMailCount } from '../store/slices/my_agencies';

const POLLING_INTERVAL_MS = 60000; // 1 minuto

const useUnreadCount = () => {
  const dispatch = useDispatch();
  const agencieSelected = useSelector((state) => state.myAgencies?.selected_agencie_to_consult);
  const unreadCount = useSelector((state) => state.myAgencies?.unreadMailCount ?? 0);

  const fetchCount = useCallback(async () => {
    if (!agencieSelected?.id) return;
    const count = await getUnreadCount(agencieSelected.id);
    dispatch(setUnreadMailCount(count));
  }, [agencieSelected?.id, dispatch]);

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, POLLING_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [fetchCount]);

  return { unreadCount, refreshUnreadCount: fetchCount };
};

export default useUnreadCount;
